import { useEffect } from 'react';

import { Button, Modal, ModalActions, ModalContent, ModalHeader, Typography } from '@braskai/ui-kit';

import { CardMedia } from '@mui/material';

import { useOnboardingEvent } from '@/features/user/onboarding';

import { useGetSpaces } from '@/entities/teamspace';
import { useOnboardingStore } from '@/entities/user/currentUser';

import WelcomeImage from '@/shared/assets/images/teamspace-welcom-banner.jpg';

import { useTeamspaceWelcomeModal } from '../model/useTeamspaceWelcomeModal';

export const TeamspaceWelcomeModal = () => {
  const { spaceId, reset } = useTeamspaceWelcomeModal();
  const changeStepStatus = useOnboardingStore((state) => state.changeStepStatus);
  const { data: spaces } = useGetSpaces();
  const showOnboardingEvent = useOnboardingEvent('manageTeamspace_v1', true);

  const spaceName = spaces?.find((space) => space.id === spaceId)?.name || '';

  const onClose = () => {
    reset();

    showOnboardingEvent();
  };

  useEffect(() => {
    if (spaceId) {
      changeStepStatus('manageTeamspace_v1', true);
    }
  }, [spaceId, changeStepStatus]);

  if (!spaceId) {
    return null;
  }

  return (
    <Modal open onClose={onClose}>
      <ModalHeader.Container sx={{ padding: '0px !important' }} onClose={onClose}>
        <CardMedia component="img" src={WelcomeImage} />
      </ModalHeader.Container>
      <ModalContent>
        <Typography color="common.black" component="h2" variant="title-3-sb">
          Welcome to {spaceName} Teamspace!
        </Typography>
        <Typography color="grey.500" mt={1} variant="body-1">
          You’ve been invited to collaborate with your team on video localization projects. <br /> Get started by
          creating your first video in the current Translation tab and follow the onboarding steps.
        </Typography>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose}>Get started</Button>
      </ModalActions>
    </Modal>
  );
};
